import {
  PromotionRecommendationRejectionReason,
  PromotionRecommendationsGroupedByProduct,
} from 'common/api-types/recommendations';

export function getRecommendationItems(
  ids: string[],
  items: PromotionRecommendationsGroupedByProduct[],
) {
  return items
    .flatMap(({ venueItems }) => venueItems.filter((venueItem) => ids.includes(venueItem.id)))
    .map(({ id, version }) => ({ id, version }));
}

export const reasons: PromotionRecommendationRejectionReason[] = [
  'NO_VENDOR_FUNDING',
  'UNRELIABLE_MARGIN_DATA',
  'LOW_PROMOTION_POTENTIAL',
  'SEASONAL_PRODUCT',
  'STOCK_CONSTRAINTS',
  'LEGAL_BLOCKER',
  'CANNIBALIZATION_RISK',
  'BRAND_RELATIONSHIP_RISK',
  'OTHER',
];
